import { P, Predicate } from "breadcommon";
import { useContext } from "react";
import { TagsContext } from "../firebaseio/TagsContext";

export interface TransactionColumnFilterDisplayTagsProps {
  predicate: Predicate;
}

export function TransactionColumnFilterDisplayTags({
  predicate,
}: TransactionColumnFilterDisplayTagsProps): JSX.Element {
  const tags = useContext(TagsContext);

  // Parse the predicate to extract selected tag IDs
  // Expected structure: P.Any(P.ListContains(P.Field("tagIds"), P.Literal(id1)), ...)
  // or a single P.ListContains(P.Field("tagIds"), P.Literal(id))
  const serializable = predicate.asSerializable();

  const tagIds: string[] = [];

  const extractIdFromIncludes = (op: {
    name: P.OpName;
    args: any[];
  }): string | null => {
    if (op.name !== P.OpName.ListContains || op.args.length !== 2) return null;
    const literalOp = op.args[1];
    if (
      literalOp.name === P.OpName.Literal &&
      typeof literalOp.args[0] === "string"
    ) {
      return literalOp.args[0];
    }
    return null;
  };

  if (serializable.name === P.OpName.Any && serializable.args.length > 0) {
    for (const arg of serializable.args) {
      const id = extractIdFromIncludes(arg);
      if (id !== null) tagIds.push(id);
    }
  } else if (serializable.name === P.OpName.ListContains) {
    const id = extractIdFromIncludes(serializable);
    if (id !== null) tagIds.push(id);
  }

  const tagNames = tagIds
    .map((id) => tags.get(id)?.name)
    .filter((name): name is string => name !== undefined);

  if (tagNames.length === 0) {
    return <span>Tags filter</span>;
  } else if (tagNames.length === 1) {
    return <span>Tagged {tagNames[0]}</span>;
  } else if (tagNames.length <= 3) {
    return <span>Tagged {tagNames.join(", ")}</span>;
  } else {
    return (
      <span>
        Tagged {tagNames.slice(0, 2).join(", ")}, +{tagNames.length - 2} more
      </span>
    );
  }
}
